import React from 'react';
import SGREForecastPage from './SGREForecast';
import { useUser } from '../contexts/UserContext';

export default function SGREForecastRoute() {
  const { user } = useUser();

  return (
    <SGREForecastPage
      backendUrl={process.env.REACT_APP_BACKEND_URL}
      user={user}
    />
  );
}
